class LoggerService {

    constructor(log, toastr, appInsightsService) {
        this.log = log;
        this.toastr = toastr;
        this.appInsightsService = appInsightsService;
    }

    getLogFn (moduleId, fnName) {
        fnName = fnName || 'log';
        switch (fnName.toLowerCase()) { // convert aliases
        case 'success':
            fnName = 'logSuccess';
            break;
        case 'error':
            fnName = 'logError';
            break;
        case 'warn':
            fnName = 'logWarning';
            break;
        case 'warning':
            fnName = 'logWarning';
            break;
        }

        var logFn = service[fnName] || service.log;
        return function(msg, data, showToast) {
            logFn(msg, data, moduleId, (showToast === undefined) ? true : showToast);
        };
    }

    log (message, data, source, showToast) {
        this._logIt(message, data, source, showToast, 'info');
    }

    logWarning (message, data, source, showToast) {
        this._logIt(message, data, source, showToast, 'warning');
    }

    logSuccess (message, data, source, showToast) {
        this._logIt(message, data, source, showToast, 'success');
    }

    logError (message, data, source, showToast) {
        this._logIt(message, data, source, showToast, 'error');
    }

    _logIt (message, data, source, showToast, toastType) {
        let write = (toastType === 'error') ? this.log.error : this.log.log;
        source = source ? '[' + source + '] ' : '';
        write(source, message, data);
        if (showToast) {
            if (toastType === 'error') {
                this.toastr.error(message);
                this.appInsightsService.logError(data, message);
            } else if (toastType === 'warning') {
                this.toastr.warning(message);
            } else if (toastType === 'success') {
                this.toastr.success(message);
            } else {
                this.toastr.info(message);
            }
        }
    }

    static loggerServiceFactory($log, toastr, appInsightsService) {
        return new LoggerService($log, toastr, appInsightsService);
    }
}

LoggerService.loggerServiceFactory.$inject = ['$log', 'toastr', 'appInsightsService'];

export default LoggerService;


// WEBPACK FOOTER //
// ./app/services/logger.service.js